import {useEffect} from 'react';
import {useInView} from 'react-intersection-observer';
import {TitleBar} from '../../../../design-system/organisms/TitleBar/TitleBar';
import {TitleBarType} from '../../../../design-system/organisms/TitleBar/TitleBarType.enum';
import {SchemeSection, SectionType} from '../../../../graphql/generated/types';
import {aggregateAndSendLog} from '../../../../logging/aggregateAndSendLog';
import {LOG_CLICK_EVENT} from '../../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../../logging/putTiaraObjectProps';
import {CommonSectionProps} from '../../type';

export function Ranking({section, children}: CommonSectionProps) {
  const {title} = section;
  const isRankingTheme = section.type === SectionType.RankingTheme;
  const {ref, inView, entry} = useInView();
  useEffect(() => {
    if (inView && entry?.target) {
      aggregateAndSendLog({
        targetElem: entry.target as HTMLElement,
        actionType: 'ViewImp',
        actionName: '섹션_노출',
        customProps: {
          user_action: 'imp',
        },
        viewimp_contents: {
          imp_type: 'vimp',
        },
      });
    }
  }, [entry, inView]);
  const scheme =
    'scheme' in section ? (section as SchemeSection).scheme : undefined;
  return (
    <div
      ref={ref}
      {...putTiaraObjectProps({
        viewimp_contents: {
          imp_id: isRankingTheme ? 'ranking_theme' : 'ssranking',
          imp_provider: 'service',
          layer1: isRankingTheme ? '랭킹테마' : '서브랭킹',
        },
        click: {
          imp_id: isRankingTheme ? 'ranking_theme' : 'ssranking',
          layer1: isRankingTheme ? '랭킹테마' : '서브랭킹',
          imp_provider: 'service',
        },
        customProps: {
          section_title: title,
          section_type: isRankingTheme ? '랭킹테마' : '서브랭킹',
        },
      })}
    >
      <TitleBar
        className="mb-4pxr"
        type={TitleBarType.Main}
        title={title || undefined}
        scheme={'scheme' in section ? scheme : undefined}
        onClickMore={e => LOG_CLICK_EVENT('더보기_클릭', e)}
        {...putTiaraObjectProps({
          eventMeta: {
            id: scheme,
            type: 'scheme',
            provider: '서비스',
          },
          customProps: {
            landing_path: isRankingTheme ? 'ranking_theme' : 'ranking',
          },
        })}
      />
      {children}
    </div>
  );
}
